export default __webpack_public_path__ + "static/1-6432cec085a7883059dabaf9d5c85067.jpg";